import ActionCreator from "../actionCreator";

export default {
    getAllItems: ActionCreator("SUPPORT_MAP_GET_ALL_ITEMS"),
    saveItems: ActionCreator("SUPPORT_MAP_SAVE_ITEMS"),
    toggleSearchActive: ActionCreator("SUPPORT_MAP_TOGGLE_SEARCH"),
    setQuerySearch: ActionCreator("SUPPORT_MAP_SET_QUERY_SEARCH"),
    errorResponse: ActionCreator("ERROR_RESPONSE_SUPPORT_MAP"),
};
